import { styled } from "goober";

export const SpreadsheetTable = styled("table")`
  width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled("thead")`
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const Th = styled("th")`
  background: var(--surface-primary);
  box-shadow: inset 0 -0.5px 0 var(--border-alpha);
  border-right: 0.5px solid var(--border-alpha);
  padding: 0 24px 2px;
  min-width: 120px;
  min-height: 48px;
  height: 48px;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:last-child {
    border-right: none;
  }
`;

export const Td = styled("td")`
  border-bottom: 0.5px solid var(--border-alpha);
  border-right: 0.5px solid var(--border-alpha);
  padding: 0 24px 2px;
  min-width: 120px;
  min-height: 48px;
  height: 48px;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: var(--surface-hover);
  }
`;
